const swal = require('sweetalert');
const $ = require('jquery');

$(document).on('click', '.btn-dropout', function () {
    const button = $(this);
    const playerId = button.data('player-id');
    const tourneyId = button.data('tourney-id');
    const confirmTitle = button.data('confirm-title');
    const confirmText = button.data('confirm-text');
    const confirmButton = button.data('confirm-button');
    const cancelButton = button.data('cancel-button');

    swal({
        title: confirmTitle,
        text: confirmText,
        icon: "warning",
        buttons: {
            cancel: {
                text: cancelButton,
                value: null,
                visible: true,
                className: "",
                closeModal: true,
            },
            confirm: {
                text: confirmButton,
                value: true,
                visible: true,
                className: "btn-danger",
                closeModal: true
            }
        },
        dangerMode: true,
    })
        .then((willDelete) => {
            if (willDelete) {
                window.location.href = `/tourneys/${tourneyId}/dropout/${playerId}`;
            } else {
                swal({
                    text: "The player is still in the tourney!",
                    icon: "info",
                });
            }
        });
});
